export default __webpack_public_path__ + "static/media/icon_category-others.e3762469.svg";